<template>
    <div class="flex items-center space-x-1">
        <select class="border border-grey-200 bg-white px-4 py-2 rounded-md text-base font-medium text-grey-800"
                v-model="sortBy"
                id="sort">
            <option v-for="option in options" :value="option">
                Sort by {{ option }}
            </option>
        </select>
        <div class="text-grey-500 cursor-pointer t-300 hover:opacity-70" @click="changeSortDirection">
            <div v-if="sortDirection === 'asc'">
                <sort-direction-icon/>
            </div>
            <div v-else>
                <sort-direction-icon class="rotate-180"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        SortDirectionIcon: () => import('../Icons/SortDirectionIcon.vue')
    },
    props: {
        value: {
            type: Object,
            required: false,
        },
        options: {
            type: Array,
            required: false,
            default() {
                return ['name', 'sku'];
            },
        },
    },
    data(){
        return {
            sortBy: this.value ? this.value.by : this.options[0],
            sortDirection: this.value ? this.value.direction : 'asc'
        }
    },
    methods: {
        changeSortDirection() {
            if(this.sortDirection === 'asc'){
                this.value.direction = 'desc';
            } else {
                this.value.direction = 'asc';
            }
            this.sortDirection = this.value.direction;
            this.$emit('sort', this.value);
        },
    },
    watch: {
        sortBy(){
            this.value.by = this.sortBy;
            this.$emit('sort', this.value);
        }
    },
};
</script>
